export default __webpack_public_path__ + "static/media/mobile.a8468f59.png";